import { render } from "./FriendList.vue?vue&type=template&id=e1bed82c&scoped=true"
import script from "./FriendList.vue?vue&type=script&lang=js"
export * from "./FriendList.vue?vue&type=script&lang=js"

import "./FriendList.vue?vue&type=style&index=0&id=e1bed82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1bed82c"]])

export default __exports__